import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm, Controller, set } from 'react-hook-form'
import { Button, TextField, MenuItem } from '@mui/material'
import axios from 'axios'
import banner from 'resources/images/contactUsBanner.jpg'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
import Alert from '@mui/material/Alert'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export default function ContactUs() {
    const [tip, setTip] = React.useState('')
    const [state, setState] = React.useState('')
    const [open, setOpen] = React.useState(false)
    const handleOpen = () => {
        setOpen(true)
        setTimeout(() => setOpen(false), 5000)
    }

    const handleClose = () => {
        setOpen(false)
    }
    const {
        t,
        i18n: { language },
    } = useTranslation()
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors },
        trigger,
    } = useForm({ mode: 'onBlur' })
    const [isPending, setIsPending] = useState(false)
    const onSubmit = (form) => {
        console.log('from', form)
        setIsPending(true)
        const params = { ...form, domainId: 13 }
        axios
            .post('https://erp.sinoasia.net/admin-api/sm/websiteEnquiry/add', params)
            .then((res) => {
                console.log('res', res)
                if (res.data.code === 200) {
                    setTip(t('contactUs.sendEmailSuccess'))
                    setState('success')
                } else {
                    setTip(t('contactUs.sendEmailFail'))
                    setState('error')
                }
                handleOpen()
                setIsPending(false)
            })
            .catch((err) => {
                setTip(t('contactUs.sendEmailFail'))
                console.log('err', err)
            })
    }
    return (
        <div className='bg-[#f4f7fc]'>
            {open && (
                <Alert className=' fixed top-10 z-50 left-1/2 -translate-x-1/2' severity={state}>
                    {tip}
                </Alert>
            )}
            <div className='w-full aspect-[18/5]  max-h-[400px] relative'>
                <img src={banner} className='w-full h-full object-center object-cover' alt='' />
                <div className='absolute top-0 left-0 w-full h-full bg-[#00000080] opacity-60'></div>
                <h1 className='absolute z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#fff] text-[4.5vw] font-medium'>
                    {t('home.contactUs')}
                </h1>
            </div>
            <form
                className='w-ful flex flex-col gap-10 px-5 mx-auto py-8 md:py-12 md:w-[500px] lg:py-15 lg:w-[800px] xl:py-[100px]'
                onSubmit={handleSubmit(onSubmit)}
                autoComplete='off'
            >
                <div>
                    <h2 className='text-4xl text-center font-bold'>{t('contactUs.title')}</h2>
                    <p className='text-lg font-medium text-center italic'>{t('contactUs.description')}</p>
                </div>

                <div className='flex gap-5 flex-col md:flex-row'>
                    <TextField
                        {...register('name', {
                            required: t('contactUs.noNull'),
                        })}
                        className='w-full md:w-1/2'
                        variant='outlined'
                        InputLabelProps={{
                            shrink: true,
                        }}
                        color='primary'
                        label={<span className='block mb-1 text-sm'>{t('contactUs.name')}</span>}
                        placeholder={t('contactUs.name')}
                        error={!!errors?.name}
                        helperText={typeof errors.name?.message === 'string' ? errors.name.message : ''}
                    />
                    <TextField
                        {...register('companyName', {
                            required: t('contactUs.noNull'),
                        })}
                        className='w-full md:w-1/2'
                        variant='outlined'
                        InputLabelProps={{
                            shrink: true,
                        }}
                        color='secondary'
                        label={<span className='block mb-1 text-sm'>{t('contactUs.companyName')}</span>}
                        placeholder={t('contactUs.companyName')}
                        error={!!errors?.companyName}
                        helperText={typeof errors.companyName?.message === 'string' ? errors.companyName.message : ''}
                    />
                </div>
                <div className='flex gap-5 flex-col md:flex-row'>
                    <TextField
                        {...register('email', {
                            required: t('contactUs.noNull'),
                            pattern: {
                                value: EMAIL_REGEX,
                                message: t('contactUs.emailInvalid'), // 正则失败提示
                            },
                        })}
                        className='w-full md:w-1/2'
                        variant='outlined'
                        InputLabelProps={{
                            shrink: true,
                        }}
                        color='secondary'
                        label={<span className='block mb-1 text-sm'>{t('contactUs.email')}</span>}
                        placeholder={t('contactUs.email')}
                        error={!!errors?.email}
                        helperText={typeof errors.email?.message === 'string' ? errors.email.message : ''}
                    />
                    <TextField
                        {...register('subject', {
                            required: t('contactUs.noNull'),
                        })}
                        className='w-full md:w-1/2'
                        variant='outlined'
                        InputLabelProps={{
                            shrink: true,
                        }}
                        color='secondary'
                        label={<span className='block mb-1 text-sm'>{t('contactUs.subject')}</span>}
                        placeholder={t('contactUs.subject')}
                        error={!!errors?.subject}
                        helperText={typeof errors.subject?.message === 'string' ? errors.subject.message : ''}
                    />
                </div>
                <TextField
                    {...register('message', { required: false })}
                    className='w-full'
                    rows={5}
                    variant='outlined'
                    multiline
                    InputLabelProps={{
                        shrink: true,
                    }}
                    label={<span className='block mb-1 text-sm'>{t('contactUs.message')}</span>}
                    placeholder={t('contactUs.message')}
                    error={!!errors?.message}
                    helperText={errors?.message?.message ?? null}
                />
                <Button
                    disabled={isPending}
                    //   variant="primaryRed"
                    size='large'
                    className='mx-auto h-fit leading-8 text-lg'
                    fullWidth
                    sx={{
                        background:
                            'linear-gradient(45deg, #8f0044, #bc003c, #e20030, #ff1636), linear-gradient(73deg, #8F0044 11.91%, #BC003C 37.3%, #E20030 63.49%, #FF1636 88.09%)',
                        color: '#fff',
                        fontWeight: 600,
                        fontFamily: 'Barlow, gf_Noto_Sans_SC',
                        borderRadius: '20px',
                    }}
                    type='submit'
                >
                    {t('contactUs.submit')}
                </Button>
            </form>
        </div>
    )
}
